import { Link, NavLink } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AdminLoginButton } from "@/components/AdminLoginButton";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { CATEGORIES } from "@/constants/data";

/**
 * Desktop (lg+) navigation: Kurumsal dropdown, category links, phone number, CTA button.
 */
const DesktopNav = ({ onOpenInquiry }) => (
  <>
    <nav className="hidden lg:flex items-center gap-1">
      <NavigationMenu>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger
              data-testid="nav-kurumsal-trigger"
              className="bg-transparent font-medium text-sm hover:bg-[color:hsl(var(--secondary))] data-[state=open]:bg-[color:hsl(var(--secondary))]"
            >
              Kurumsal
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <div className="w-[260px] p-2 flex flex-col">
                <NavigationMenuLink asChild>
                  <Link
                    data-testid="nav-hakkimizda-link"
                    to="/hakkimizda"
                    className="block rounded-[10px] px-3 py-2.5 text-sm hover:bg-[color:hsl(var(--secondary))] transition-colors"
                  >
                    Hakkımızda
                  </Link>
                </NavigationMenuLink>
                <NavigationMenuLink asChild>
                  <Link
                    data-testid="nav-vizyon-link"
                    to="/vizyon-misyon"
                    className="block rounded-[10px] px-3 py-2.5 text-sm hover:bg-[color:hsl(var(--secondary))] transition-colors"
                  >
                    Vizyonumuz &amp; Misyonumuz
                  </Link>
                </NavigationMenuLink>
              </div>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      {CATEGORIES.map((cat) => (
        <NavLink
          key={cat.value}
          to={`/kategori/${cat.value}`}
          data-testid={`nav-category-${cat.value}`}
          className="gold-hairline relative px-3 py-2 text-sm font-medium text-[color:var(--brand-charcoal)] transition-colors"
        >
          {cat.label}
        </NavLink>
      ))}
    </nav>

    <div className="hidden lg:flex items-center gap-3">
      <a
        href="tel:+903122771272"
        data-testid="navbar-phone-link"
        className="flex items-center gap-1.5 text-sm text-[color:hsl(var(--muted-foreground))] hover:text-[color:var(--brand-charcoal)] transition-colors"
      >
        <Phone className="h-3.5 w-3.5" />
        0312 277 12 72
      </a>
      <AdminLoginButton variant="navbar" />
      <Button
        data-testid="navbar-cta-button"
        onClick={onOpenInquiry}
        className="bg-[linear-gradient(135deg,#D4AF37_0%,#C5A059_55%,#E7D7A6_100%)] text-[color:var(--brand-charcoal)] h-11 px-5 rounded-[10px] font-medium shadow-[0_10px_30px_rgba(43,43,43,0.10)] hover:shadow-[0_16px_44px_rgba(43,43,43,0.14)] hover:-translate-y-[1px] transition-[box-shadow,transform] duration-200"
      >
        Talep Oluştur
      </Button>
    </div>
  </>
);

export default DesktopNav;
